import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function CategorySection() {
  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
            影视分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类型浏览，快速找到你想看的</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.filter(c => c.slug !== "all").map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 md:p-5 rounded-lg bg-background-50 border border-background-200/50 hover:border-primary-500/40 hover:bg-background-50 transition-all cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100/50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}